import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

const EmptyCart = () => {
  return (
    <div className="bg-softRose min-h-screen flex items-center justify-center px-4">
      <div className="text-center bg-white p-8 rounded-lg shadow-sm max-w-md">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <h2 className="mt-4 text-2xl font-bold text-gray-900">Your cart is empty</h2>
        <p className="mt-2 text-gray-600">
          Looks like you haven't added any items to your cart yet.
        </p>
        <div className="mt-6">
          {/* Option 1: Use Link directly (recommended) */}
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-pinkAccent hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pinkAccent"
          >
            Continue Shopping
          </Link>
          
        </div>
      </div>
    </div>
  );
};

export default EmptyCart;